function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.091h30v21.818H0V4.091Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.182,4.091h5.455v21.818h-5.455V4.091Z",
    style: {
      fill: "#005eb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12.273h30v5.455H0v-5.455Z",
    style: {
      fill: "#005eb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.545,4.091h2.727v21.818h-2.727V4.091Z",
    style: {
      fill: "#ef3340"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13.636h30v2.727H0v-2.727Z",
    style: {
      fill: "#ef3340"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFo);
export default __webpack_public_path__ + "static/media/FO.8844400045205b8b08c7eb8d1f7ef331.svg";
export { ForwardRef as ReactComponent };